import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { ImportPage } from '~/features/imports/import-page';

function ImportRoute(): ReactElement {
  const { importId } = Route.useParams();
  return <ImportPage importId={importId} />;
}

/** One import, on OS's page: the step waiting, the progress, or the report (Decided 14 to 17). */
export const Route = createFileRoute('/_app/coach/imports/$importId/')({ component: ImportRoute });
